import * as React from "react";
const SvgFiRrDiamond = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-diamond_svg__a)">
      <path
        fill="#062147"
        d="m23.22 5.743-3.011-4.068A4 4 0 0 0 16.955 0h-9.91A4 4 0 0 0 3.8 1.656L.735 5.753a3.99 3.99 0 0 0 .123 4.784L9.65 22.865A2.98 2.98 0 0 0 12 24a3 3 0 0 0 2.378-1.175L23.1 10.634a4 4 0 0 0 .12-4.891m-4.628-2.892 3.018 4.078c.016.022.02.048.036.071h-4.892l-1.428-5h1.629a2.01 2.01 0 0 1 1.637.851M12 19.118 9.3 9h5.4zM9.326 7l1.428-5h2.492l1.428 5zm-3.91-4.163A2 2 0 0 1 7.046 2h1.629L7.246 7H2.318c.014-.022.018-.049.034-.07zM2.449 9.325A2 2 0 0 1 2.263 9h4.969l2.994 11.23zM13.77 20.24l3-11.24h4.986a2 2 0 0 1-.243.421z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-diamond_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiamond;
